module.exports = __webpack_public_path__ + "static/media/body_alt_bkgrnd.3f03714f.jpeg";